<template>
  <div class="px-4 py-8">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
      :blur="''"
    ></loading>
    <div>
      <v-wait for="settings">
        <half-circle-spinner
          slot="waiting"
          style="display: block; margin: 0 auto"
          :animation-duration="1000"
          :size="60"
          color="#3d4852"
        />
        <div class="">
          <div
            class="flex payment-gateway-list flex-wrap -mt-4 -mx-2"
            v-if="localGatewayIntegrations && localGatewayIntegrations.length >= 0"
          >
          <div class="px-3">
            <div class="gateway-column-content my-4 border border-solid border-grey-200 rounded-lg flex flex-col bg-white justify-center items-center cursor-pointer" @click="openGatewayModal">
              <span class="text-6xl font-bold text-pink">+</span>
            </div>
              <payment-gateway
                :localGatewayList="localGatewayIntegrations"
                @updateIntegration="localGatewayIntegrations = $event"
              ></payment-gateway>
          </div>
            <div
              v-for="(
                gatewayIntegration, gatewayIntegrationIndex
              ) in localGatewayIntegrations"
              :key="gatewayIntegrationIndex"
              class="px-3"
            >
              <gateway-asset
                :gatewayIntegration="gatewayIntegration"
                @onProcessingFeeClick="openProcessingFeeModal"
              />
            </div>
          </div>
          <div v-else>
            <div class="px-3">
            <div class="gateway-column-content my-4 border border-solid border-grey-200 rounded-lg flex flex-col bg-white justify-center items-center cursor-pointer" @click="openGatewayModal">
              <span class="text-6xl font-bold text-pink">+</span>
            </div>
              <payment-gateway
                :localGatewayList="localGatewayIntegrations"
                @updateIntegration="localGatewayIntegrations = $event"
              ></payment-gateway>
          </div>
          </div>
        </div>

        <gd-modal name="add-processing-fees-modal" :title="$t('frontend_groovesell_estimated_merchant_fee')">
          <div
            class="px-8 py-6"
            v-if="
              !['groovepay_automated', 'paypal', 'paypal_commerce'].includes(
                editingIntegration.platform
              )
            "
          >
            <div class="flex mb-5 text-grey-700">
              <i class="fas fa-info-circle mt-1"></i>
              <div class="font-semibold text-sm ml-2">
                Enter your average merchant processing fee. This is used in reports when calculating profits if we can't obtaining the fee from your processor. This is also used when you select the option to pay your affiliate on the Gross Mount after processing fees are deducted.
                </div>
            </div>
            <div class="flex flex-col mb-4">
              <label class="font-semibold text-sm text-grey-700 mb-2"
                >{{ $t('frontend_groovesell_per_transaction_rates') }} (%)</label
              >
              <text-input
                v-model="editingIntegration.percentage"
                :validator="$v.selectedIntegrationName"
                :attribute="$t('frontend_name')"
                class="text-dark text-sm"
                :placeholder="$t('frontend_percentage')"
              />
            </div>
            <div class="flex flex-col mb-4">
              <label class="font-semibold text-sm text-grey-700 mb-2"
                >{{ $t('frontend_groovesell_per_transaction_fee') }} ($)</label
              >
              <text-input
                v-model="editingIntegration.per_transaction_fee"
                :validator="$v.selectedIntegrationName"
                :attribute="$t('frontend_name')"
                class="text-dark text-sm"
                :placeholder="$t('frontend_groovesell_transaction_fee')"
              />
            </div>
            <div class="flex justify-end">
              <gd-button
                class="
                  h-10
                  btn-width
                  px-4
                  btn-radius
                  text-base
                  font-semibold
                  ml-4
                "
                size="auto"
                primary
                @click="updateIntegration"
                >{{ $t('frontend_update') }}</gd-button
              >
            </div>
          </div>
          <div class="px-8 py-6" v-else>
            {{
              editingIntegration.platform.startsWith('paypal')
                ? 'PayPal'
                : 'GroovePay'
            }}
            {{ $t('frontend_groovesell_funnels_settings_fee_auto_calc_api') }}
          </div>
        </gd-modal>
      </v-wait>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import themeConfig from './theme/themeConfig.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import Integration from './models/Integration';
import GatewayAsset from './components/GatewayAsset';
import PaymentGateway from './components/PaymentGatewayModal';

export default {
  middleware: 'auth',
  components: {
    Loading,
    GatewayAsset,
    PaymentGateway,
  },
  data() {
    return {
      isLoading: false,
      fullPageLoader: true,
      loaderColor: themeConfig.appPrimaryColor,
      localGatewayIntegrations: this.gatewayIntegrations,
      editingIntegration: {
        percentage: 0,
        per_transaction_fee: 0,
      },
    };
  },
  validations: {},
  computed: {
    paypalIntegrations() {
      return this.localGatewayIntegrations.filter((integration) => {
        return (
          integration.platform == 'paypal' ||
          integration.platform == 'paypal_commerce'
        );
      });
    },

    cardIntegrations() {
      return this.localGatewayIntegrations.filter((integration) => {
        return (
          integration.platform != 'paypal' &&
          integration.platform != 'paypal_commerce'
        );
      });
    },
  },
  watch: {
    localGatewayIntegrations() {
      this.$emit('updateIntegration', this.localGatewayIntegrations);
    },
  },
  async created() {
    this.$wait.start('settings');
    this.localGatewayIntegrations = await Integration.$get();
    this.$wait.end('settings');
  },
  methods: {
    async updateIntegration() {
      this.showLoader();
      await this.editingIntegration.save();
      console.log(
        `this.editingIntegration ${JSON.stringify(this.editingIntegration)}`
      );
      this.$root.$emit('modal-close', 'add-processing-fees-modal');
      this.hideLoader();
    },

    async openProcessingFeeModal(gatewayId) {
      this.showLoader();
      this.editingIntegration = await Integration.$find(gatewayId);
      console.log(`this.editingIntegration ${this.editingIntegration}`);
      this.$root.$emit('modal-open', 'add-processing-fees-modal');
      this.hideLoader();
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },

    integrationName(id) {
      const integration = this.localGatewayIntegrations.find((obj) => {
        return obj.id === id;
      });

      return integration.name;
    },
    openGatewayModal() {
      this.$root.$emit('modal-open', 'payment-gateway-modal');
    },
  },
};
</script>

<style lang="scss">
.payment-gateway-list:empty::before {
  content: "You currently don't have any payment gateways added in your account. Click on 'Add New Payment Gateway' to add your first gateway.";
  color: #191d3a;
  margin: 10px auto;
  text-align: center;
}
</style>
